<script lang="ts">
  import { Store, UIEventSource } from "../../Logic/UIEventSource"
  import { Tag } from "../../Logic/Tags/Tag"
  import type { SpecialVisualizationState } from "../SpecialVisualization"
  import LoginToggle from "../Base/LoginToggle.svelte"
  import Tr from "../Base/Tr.svelte"
  import Loading from "../Base/Loading.svelte"
  import TagApplyViz from "./TagApplyViz"
  import Icon from "../Map/Icon.svelte"
  import { And } from "../../Logic/Tags/And"
  import Translations from "../i18n/Translations"
  import TagHint from "../Popup/TagHint.svelte"

  /**
   * Works closely together with 'TagApplyViz
   */
  export let msg: string
  export let image: string | undefined
  export let tags: Store<Record<string, string>>
  export let tagsToApply: Store<Tag[]>
  export let targetIdKey: string
  export let onApply: () => Promise<void>
  export let state: SpecialVisualizationState
  const t = Translations.t.general.apply_button
  // THis button might be shown on MapRoulette-items, which might already have been applied
  // This will default to 'false' for non-maproulette challenges
  let isMaprouletteAndApplied =
    tags?.data?.["mr_taskStatus"] !== undefined && tags?.data?.["mr_taskStatus"] !== "Created"

  let currentState: UIEventSource<"init" | "applying" | "applied"> = new UIEventSource(
    isMaprouletteAndApplied ? "applied" : "init"
  )

  async function apply() {
    currentState.set("applying")
    await onApply()
    currentState.set("applied")
  }
</script>

<LoginToggle {state} ignoreLoading>
  {#if $currentState === "init"}
    <button on:click={() => apply()}>
      <Icon icon={image} />
      <div class="flex flex-col">
        <div>{msg}</div>
        {#if targetIdKey}
          <Tr
            cls="subtle break-all"
            t={t.appliedOnAnotherObject.Subs({
              id: $tags[targetIdKey],
              tags: new And($tagsToApply).asHumanString(false, false, {}),
            })}
          />
        {:else}
          <TagHint tags={$tagsToApply} />
        {/if}
      </div>
    </button>
  {:else if $currentState === "applying"}
    <Loading>
      <Tr t={t.applying} />
    </Loading>
  {:else if $currentState === "applied"}
    <Tr t={t.isApplied} cls="thanks" />
  {/if}
</LoginToggle>
